import React from 'react';
import { Button, Card, Row, Col, Form, Spinner } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import './../sharedStyles.css'

const formatarData = (data) => {
  if (!data) return '';
  return new Date(`${data}T00:00:00`).toLocaleDateString('pt-BR');
};

const InspetorChart = ({
  dataInspecoes,
  dataInicio,
  dataFim,
  dataInicioAplicada,
  dataFimAplicada,
  loading,
  onDataInicioChange,
  onDataFimChange,
  onFiltrar
}) => {

  const labels = dataInspecoes?.map(item => item.inspetor);
  const dataValues2 = dataInspecoes?.map(item => item.quantidadeInspecoes);

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Inspeções',
        data: dataValues2,
        backgroundColor: '#CCE5FF',
        borderColor: 'rgba(3, 2, 103, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Opções do gráfico
  const options = {
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top'
      },
      title: {
        display: false,
        text: 'Horizontal Bar Chart',
      },
    },
  };

  const periodoInvalido = !dataInicio || !dataFim || dataInicio > dataFim;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!periodoInvalido) onFiltrar();
  };

  return (
    <>
      <Row className='mt-3 g-3'>
        <Col>
          <Card>
            <Card.Header className='card-chart-title'>
              Total inspeções por Inspetor - {formatarData(dataInicioAplicada)} a {formatarData(dataFimAplicada)}
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit} className='mb-3'>
                <Row className='g-2 align-items-end'>
                  <Col xs={12} sm={5} md={4}>
                    <Form.Group controlId='dataInicioInspetores'>
                      <Form.Label>Data inicial</Form.Label>
                      <Form.Control type='date' value={dataInicio}
                        onChange={(event) => onDataInicioChange(event.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={5} md={4}>
                    <Form.Group controlId='dataFimInspetores'>
                      <Form.Label>Data final</Form.Label>
                      <Form.Control type='date' value={dataFim}
                        min={dataInicio}
                        onChange={(event) => onDataFimChange(event.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={2} md='auto'>
                    <Button type='submit' disabled={periodoInvalido || loading} className='w-100'>
                      {loading ? <><Spinner animation='border' size='sm' className='me-2' />Atualizando</> : 'Atualizar'}
                    </Button>
                  </Col>
                </Row>
                {periodoInvalido && (
                  <div className='text-danger mt-2'>A data inicial deve ser anterior ou igual à data final.</div>
                )}
              </Form>
              <Bar data={data} options={options} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default InspetorChart;
